<template>
  <Transition
    name="expand"
    @enter="enter"
    @after-enter="afterEnter"
    @leave="leave"
  >
    <div v-if="cartWarnings" class="cart-warnings">{{ cartWarnings }}</div>
  </Transition>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  name: "CartWarnings",
  computed: {
    ...mapState("cart", ["cartWarnings"]),
  },
  mounted() {
    setTimeout(() => {
      this.setCartWarnings("");
    }, 5000);
  },
  methods: {
    ...mapActions("cart", ["setCartWarnings"]),
    enter(element) {
      element.style.height = "0";

      requestAnimationFrame(() => {
        element.style.height = element.scrollHeight + "px";
      });
    },
    afterEnter(element) {
      element.style.height = "auto";
    },
    leave(element) {
      element.style.height = element.scrollHeight + "px";

      requestAnimationFrame(() => {
        element.style.height = "0";
      });
    },
    afterLeave(element) {
      element.style.height = "auto";
    },
  },
};
</script>

<style lang="scss" scoped>
.cart-warnings {
  @include utility-label(14px);
  background-color: $color-red;
  color: $color-white;
  padding: 10px;
  margin-bottom: 20px;
}

.expand-enter-active,
.expand-leave-active {
  transition: height 250ms ease-in-out;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  height: 0;
}
</style>
